import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/rocketChatRequest'
import { IRegisterPayload } from '@app-store/slices/chat/register'

interface TaskAction extends Action {
    payload: IRegisterPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.chat.register

function* registerSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/users.create`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* registerSaga(): any {
    yield takeLatest<TaskAction>(onRequest, registerSagaTask)
}

export default registerSaga
